import { flattenGraphSequence } from './flattenGraphSequence.js';
import { deleteStepFromGraph } from './deleteStepFromGraph.js';
import { cloneWorkflowGraph } from './cloneWorkflowGraph.js';

export const removeWorkflowStepsByIds = (workflow, ids, keepChildren = false) => {
  const steps = [...(workflow?.steps || [])];
  let graph = cloneWorkflowGraph(workflow?.graph);
  const deletedScheduleStepIds = [];

  const hasFolders = steps?.some((n) => n.appSlug === 'folder');

  // Get orphan steps using sequence before anything gets deleted
  const sequenceIds = flattenGraphSequence(graph, steps, null, hasFolders)?.map((n) => n.id);
  const orphanGraphSteps = Object.keys(graph).filter((n) => !sequenceIds.includes(n));

  for (let i = 0; i < ids.length; ++i) {
    const step = steps?.find((n) => n.id === ids[i]);
    if (step?.appSlug === 'schedule') {
      deletedScheduleStepIds.push(ids[i]);
    }
    graph = deleteStepFromGraph(graph, ids[i], { keepChildren });
  }

  // Delete orphan steps from graph. I decided to do it here instead of pushing into ids to avoid cases where orphans might have exits
  for (let i = 0; i < orphanGraphSteps.length; ++i) {
    delete graph[orphanGraphSteps[i]];
  }

  // Delete orphan steps from workflow
  const orphanWorkflowSteps = steps
    ?.filter((n) => {
      return !['input', 'trigger'].includes(n.type) && !graph[n.id];
    })
    .map((n) => n.id);

  // `deletedStepIds` is the deletion RECEIPT: it filters the returned rows, drives the
  // `workflowStep` delete queue, and is what Cloudy reports to the model and the user. It must
  // therefore list only what was ACTUALLY removed — the requested ids that were present plus the
  // swept orphans — never a requested id that never existed. (Trigger/input rows are excluded from
  // the orphan sweep by type, so an explicitly requested one only reaches the receipt here.)
  const removedRequestedIds = ids.filter((id) => steps.some((n) => n?.id === id));
  const deletedStepIds = [...new Set([...orphanWorkflowSteps, ...removedRequestedIds])];

  const filteredSteps = workflow?.steps?.filter((step) => !deletedStepIds.includes(step.id)) || [];

  return { deletedStepIds, deletedScheduleStepIds, steps: filteredSteps, graph };
};
